import { CloseOutlined } from '@mui/icons-material'
import { Button, Grid, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../customTable'
import moment from 'moment'
import _ from 'lodash'
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { PictureAsPdf } from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useDispatch } from "react-redux";
import {  useNavigate } from "react-router-dom";
import axios from "axios";
import { setPDFData } from '../../../../../../components/hooks/printPdf/pdfData'
import { setSnackbar } from '../../../../../../components/hooks/snackBar/reducers'
const DayReports = ({setOpen  , dateData  , setActiveStep, setProductData}) => {
    const pageOption = [10, 25, 50, 100];
    const dispatch = useDispatch();

    const outletId = localStorage.getItem("outlet_id")
    const [page, setPage] = useState(0);
    const navigate = useNavigate()
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const onClickEdit = (e) => {
        console.log(e.row)
        setProductData(e.row.salesData)
        setActiveStep("3")
    }
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
    const convertNumber = (num) => {
      if (num === 0) return 'Zero';
  
      let words = '';
      for (let i = 0; num > 0; i++) {
        if (num % 1000 !== 0) {
          words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
        }
        num = Math.floor(num / 1000);
      }
      return words.trim();
    };
  
    const convertHundreds = (num) => {
      if (num >= 100) {
        return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
      } else {
        return convertTens(num);
      }
    };
  
    const convertTens = (num) => {
      if (num < 10) return units[num];
      else if (num < 20) return teens[num - 10];
      else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
    };
    function handlePDF(e){
      console.log(e)
      const TotalData = {
        sub_total : e.sub_total,
        gst: e.gst,
        totalAmount : e.amount,
        roundOff : e.roff,
      }
      const tableData = _.map(e.salesData, (val=>({
        pro_name : val.pro_name,
        pur_rate:val.rate,
        qty:val.qty,
        disc1:val.dis_amt,
        cgstPerc:val.gst_per,
        cgstAmnt : val.gst_amt,
        totalAmt:val.rate * val.qty
      })))
      axios.post(`/v1/outlet_sales_master/getall`,{docno : e.docNo})
      .then(res=>{
      dispatch(setPDFData({
        tableData : tableData,
        totalText : convertNumber(e.amount),
        title:'Sales Product Details',
        docNo:e.docNo,
        TotalData:TotalData
        
      }))      
      const name = `BillNo_${e.docNo}`
      navigate(`/productData/${name}`)  
      })
      .catch(err=>{
        console.log(err)
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message)
        );
      })
      
      
      // dispatch(setPDFData({
      //   tableData : e.purchase_lines,
      //   // TotalData : 
      // }))
      }
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "docNo",
            headerName: "Bill No",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "docDate",
            headerName: "Bill Date",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "outletName",
            headerName: "Outlet Name",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "gst",
            headerName: "Gst",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
          {
            field: "view",
            headerName: "View",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            disableExport: true ,
            renderCell : (params) => {
                return(
                  <div>

                    <IconButton
                    size="small"
                    onClick={() => onClickEdit(params)}
                    >
                        <VisibilityIcon />
                    </IconButton>
                    <IconButton size="small" onClick={()=>handlePDF(params.row)}>
          <PictureAsPdf sx={{fontSize: 18}} />
        </IconButton>
                    </div>
                )
            }
          },
    ]
    const rows = _.map(dateData.data,(value,idx) =>({
        id: idx,
        sno: idx+1,
        docNo:value.docno,
        docDate:moment(value.docdate).format('YYYY-MM-DD'),
        outletName:value.outlet_type_name,
        gst:value.gst_amt,
        amount:parseFloat(value.amount).toFixed(0),
        salesData : value.sales_lines,
        roff: value.roff,
        sub_total : parseFloat(value.amount - value.gst_amt - value.cess_amt + value.roff).toFixed(0) ,
    }))
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
      }
      console.log(dateData)
      useEffect(() => {
        if(dateData.data){
          setPageCount(dateData.data.length)
        }
      },[dateData])
  return (
    <Grid>
    <Grid sx={{display:"flex" , justifyContent:"space-between",padding:2,alignItems:"center"}}>
        <Button onClick={() => setActiveStep("1")} variant="contained">Back</Button>
        <Typography variant='h6'>Day reports</Typography>
        <IconButton onClick={() => {setOpen(false);setActiveStep("0")} }>
            <CloseOutlined />
        </IconButton>
    </Grid>
    <Grid>
        <CustomTable props={props}/>
    </Grid>
</Grid>
  )
}

export default DayReports